import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import RuleBuilder from './comp/ruleBuilder/RuleBuilder';
import { disabledButtonTextGray, textColorGray } from 'theme/mainColors';
import { HARDCODED_TARGET_ID_RULE_EDITOR } from 'shared/constants/SharedConstants';
import { TARGET_FIELDS_PROP_TYPE } from 'shared/constants/PropTypes';
import ExpressionParser from 'shared/helpers/ExpresionParser';
import AllocationContainer from './comp/ruleBuilder/allocationContainer/AllocationContainerConnector';

const underLineStyle = { borderColor: disabledButtonTextGray };
const floatingLabelStyle = { color: textColorGray };
const fontStyle = { fontSize: 13 };

const sqlWords = ['+', '-', '*', '/', '>', '>=', '=', '<', '<=', '<>', '[]', 'IN()', 'NOT IN()', 'AND', 'OR', 'IS', 'IS NULL'];
const sqlWordsThen = ['+', '-', '*', '/', '=', '[]','CONCAT()'];
const getSqlList = list => list.map(el => ({ name: el, label: el}));
const emptyAllocationUnit= {
  id: 0,
  name: ''
};
const emptyCostObjectList=[{
  id: 0,
  name: '',
  amount: '',
  percentageOfGross:''
}];

class RuleEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    const { name, description, thenCondition, id, ifValue, thenValue, costObjects, allocationUnit } = props.rule;
    this.state = {
      sqlList: getSqlList(sqlWords),
      sqlListThen: getSqlList(sqlWordsThen),
      validateButtonDisabled: true,
      rule: {
        id,
        name,
        description,
        ifValue,
        thenValue,
        thenCondition,
        costObjects,
        allocationUnit
      }
    };
  }

  componentDidMount = () => this.props.targetActions.fetchTargetByName(HARDCODED_TARGET_ID_RULE_EDITOR);

  componentWillReceiveProps(nextProps) {
    if(this.props.rule.thenCondition !== nextProps.rule.thenCondition){
      this.props.onAllocationUnitChange(emptyAllocationUnit);
      this.props.onCostObjectChange(emptyCostObjectList);
    }
  }

  handleThenConditionChange = (ev, index, value) => {
    this.props.onChangeRuleField('thenCondition', value);
    this.setState(oldState => ({
      rule: { ...oldState.rule, thenCondition: value },
      validateButtonDisabled: this.isValidateButtonDisabled({ ...oldState.rule, thenCondition: value })
    }));
  };

  calculateThenValue = (thenCondition, thenValue) => (thenCondition === 0 ? thenValue : `[IL_LINESTATUSID] = ${thenCondition}`);

  handleValidateRuleClick = () => {
    const { ifValue, thenCondition, thenValue } = this.state.rule;
    const parserResult = ExpressionParser.parseRule(ifValue);
    if(parserResult.isValid) {
      const rule = {
        ifJsonDefinition: parserResult.jsonObject,
        thenJsonDefinition:this.calculateThenValue(thenCondition, thenValue)
      };
      this.props.rulesActions.validateRule(rule);
    }
    else {
      console.log("Error on json expresion");
    }
  };

  handleInputChange = (ev,value) => {
    const target = ev.target;
    this.props.onChangeRuleField(target.name, value);
    this.setState(oldState => ({
      rule: { ...oldState.rule, [target.name]: value },
      validateButtonDisabled: this.isValidateButtonDisabled({ ...oldState.rule, [target.name]: value })
    }));
  };

  handleRuleBuilderChanged = (target, value) => {
    this.props.rulesActions.validationRuleReset();
    this.props.onChangeRuleField(target, value);
    this.setState(oldState => ({
      rule: { ...oldState.rule, [target]: value },
      validateButtonDisabled: this.isValidateButtonDisabled({ ...oldState.rule, [target]: value })
    }));
  };

  handleSaveClick = () => this.props.onSave(this.state.rule);

  isValidateButtonDisabled = state => (
    (state.thenCondition === 0 && state.thenValue === '') ||
    state.thenCondition === null
  );

  handleAllocationUnitChange = newAllocationUnit => this.props.onAllocationUnitChange(newAllocationUnit);

  handleCostObjectChange = newCostObjectList => this.props.onCostObjectChange(newCostObjectList);

  render() {
    const { targetFields, validationResult, validatingRule, onCancel, saveDisabled, creatingRule, rule } = this.props;
    const { sqlList, sqlListThen, validateButtonDisabled } = this.state;

    return (
      <div className="rule-editor">
        <TextField
          id="rule-editor-input-name"
          floatingLabelText="Rule Name"
          name="name"
          style={ { width: '50%' } }
          value={ rule.name }
          onChange={ this.handleInputChange }
          underlineStyle={ underLineStyle }
          floatingLabelStyle={ floatingLabelStyle }
        />
        <TextField
          id="rule-editor-input-description"
          floatingLabelText="Description"
          name="description"
          value={ rule.description }
          onChange={ this.handleInputChange }
          fullWidth={ true }
          underlineStyle={ underLineStyle }
          floatingLabelStyle={ floatingLabelStyle }
        />
        <h2>[ &nbsp; if &nbsp; ]</h2>
        <RuleBuilder id="rule-editor-if-builder" leftItems={ targetFields } rightItems={ sqlList } onValueChange={ value => this.handleRuleBuilderChanged('ifValue', value) } surroundField={ true } startingValue={ rule.ifValue } />
        <h2>[ &nbsp; then &nbsp; ]</h2>
        <SelectField
          id="rule-editor-then-conditon"
          hintText="Select"
          style={ { marginLeft: 133, verticalAlign: 'bottom', marginBottom: 7 } }
          underlineStyle={ underLineStyle }
          hintStyle={ { ...floatingLabelStyle, ...fontStyle } }
          labelStyle={ fontStyle }
          iconStyle={ { fill: textColorGray } }
          value={ rule.thenCondition }
          onChange={ this.handleThenConditionChange }
        >
          <MenuItem value={ 2 } primaryText="Flag Invoice" />
          <MenuItem value={ 1 } primaryText="Ignore" />
          <MenuItem value={ 3 } primaryText="Post" />
          <MenuItem value={ 4 } primaryText="Allocation" />
          <MenuItem value={ 0 } primaryText="Custom" />
        </SelectField>
        { rule.thenCondition === 0 && <RuleBuilder id="rule-editor-then-builder" startingValue={ rule.thenValue } leftItems={ targetFields } rightItems={ sqlListThen } onValueChange={ value => this.handleRuleBuilderChanged('thenValue', value) } surroundField={ true } /> }
        { rule.thenCondition === 4 && <AllocationContainer
          allocationUnit={ rule.allocationUnit }
          costObjects={ rule.costObjects }
          onAllocationUnitChange={ newAllocationUnit => this.handleAllocationUnitChange(newAllocationUnit) }
          onCostObjectChange={ newCostObject => this.handleCostObjectChange(newCostObject) }
        /> }
        <div className="rule-editor__validate-container">
          <SovosRaisedButton color="secondary" onClick={ this.handleValidateRuleClick } disabled={ validateButtonDisabled } >VALIDATE</SovosRaisedButton>
          <div className="rule-editor__validate-result">
            <p id="rule-editor-validationt-tex">{ validatingRule ? 'Validating Rule ...' : validationResult }</p>
          </div>
        </div>
        <hr />
        <SovosButtonsGroup align="right" style={ { marginTop: 20 } }>
          <SovosRaisedButton color="secondary" onClick={ onCancel } disabled={ creatingRule } >CANCEL</SovosRaisedButton>
          <SovosRaisedButton disabled={ saveDisabled || creatingRule } onClick={ this.handleSaveClick } >SAVE</SovosRaisedButton>
        </SovosButtonsGroup>
      </div>
    );
  }
}

RuleEditor.propTypes = {
  creatingRule: PropTypes.bool,
  rule: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    ifValue: PropTypes.string,
    thenValue: PropTypes.string,
    thenCondition:PropTypes.number,
    costObjects: PropTypes.array,
    allocationUnit: PropTypes.object
  }).isRequired,
  targetFields: TARGET_FIELDS_PROP_TYPE.isRequired,
  validationResult: PropTypes.string.isRequired,
  validatingRule: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onChangeRuleField: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  targetActions: PropTypes.shape({
    fetchTargetByName: PropTypes.func
  }).isRequired,
  rulesActions: PropTypes.shape({
    validateRule: PropTypes.func,
    createRule: PropTypes.func,
    validationRuleReset: PropTypes.func
  }).isRequired,
  onAllocationUnitChange: PropTypes.func.isRequired,
  onCostObjectChange: PropTypes.func.isRequired
};

RuleEditor.defaultProps = {
  creatingRule: false,
  validatingRule: false,
  saveDisabled: false
};

export default RuleEditor;



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/RuleEditor.js